import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { BannerBox, BannerTypes } from './BannerBox';
import { useCommon } from 'src/domains/common/Common';
import { UsersState } from 'src/domains/players/state/UsersState';
import { IdentityState } from 'src/domains/players/state/IdMission/IdentityState';

interface BannerCheckType {
    type: BannerTypes;
    shouldShow: () => boolean;
}

export const BannersContainer = observer('BannersContainer', () => {
    const common = useCommon();
    const identityState = IdentityState.get(common);
    const usersState = UsersState.get(common);

    const bannerChecks: BannerCheckType[] = [
        {
            type: BannerTypes.SRG,
            shouldShow: (): boolean => usersState.isSrgRequested,
        },
        {
            type: BannerTypes.ID_MISSION,
            shouldShow: (): boolean => {
                if (identityState === null) {
                    return false;
                }

                const processIdMission = identityState.processIdMission;
                const idMissionType = processIdMission.type ?? null;
                const isPopupOpen = processIdMission.isOpen;
                const isAuthorized = common.session.isAuthorized;

                return idMissionType !== null && isPopupOpen === false && isAuthorized;
            },
        },
    ];

    const activeBanners = bannerChecks.filter((check) => check.shouldShow());

    if (activeBanners.length === 0) {
        return null;
    }

    return (
        <>
            {activeBanners.map((banner) => (
                <BannerBox
                    key={banner.type}
                    bannerType={banner.type}
                />
            ))}
        </>
    );
});
